import {
    backgroundColorWhite,
    borderColorNormal,
    borderColorSeparate,
    ClearWhite,
    Blue,
    textColorOpacity,
} from './palette';

export const corporateHeaderSeparateBorderColor = borderColorSeparate;
export const corporateHeaderBgColor = backgroundColorWhite;
export const corporateHeaderBorder = borderColorSeparate;
export const corporateHeaderBorderUnderline = borderColorNormal;
export const corporateHeaderTextSecondary = textColorOpacity;

export const corporateHeaderCounterFont = ClearWhite;
export const corporateHeaderCounterBg = Blue;
